<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" lg="4" md="6" sm="8">
        <ValidationObserver
          ref="loginForm"
          v-slot="{
            // eslint-disable-next-line vue/no-unused-vars
            invalid,
            // eslint-disable-next-line vue/no-unused-vars
            passes,
          }"
        >
          <v-row>
            <v-col class="justify-center mb-6">
              <v-img contain src="@/assets/logo_horizontal.svg" height="55"></v-img>
            </v-col>
          </v-row>
          <v-form rel="loginForm" @submit.prevent="passes(submitLogin)">
            <v-card class="elevation-12">
              <v-card-title flat class="justify-center ma-6">
                <v-toolbar-title>Administrace</v-toolbar-title>
              </v-card-title>
              <v-card-text class="mb-0">
                <VTextFieldWithValidation
                  v-model="form.username"
                  vid="password"
                  rules="required"
                  outlined
                  dense
                  icon="mdi-account"
                  label="Uživatelské jméno"
                  data-cy="username"
                  autocomplete="username"
                />
                <VTextFieldWithValidation
                  v-model="form.password"
                  rules="required"
                  outlined
                  dense
                  icon="mdi-lock"
                  type="password"
                  label="Heslo"
                  data-cy="password"
                  autocomplete="new-password"
                />
                <router-link
                  style="text-align: right"
                  :to="{
                    name: 'password-lost',
                  }"
                >
                  <div class="pr-1">Zapomenuté heslo</div>
                </router-link>
              </v-card-text>
              <v-card-actions class="pl-4 pr-4 pb-4">
                <v-btn
                  type="submit"
                  block
                  color="primary"
                  class="button--text"
                  height="40px"
                  depressed
                  :loading="isLoggin"
                >
                  Přihlásit
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-alert v-if="errorMessage" type="error" class="mt-4">
              {{ errorMessage }}
            </v-alert>
          </v-form>
        </ValidationObserver>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      form: {
        username: '',
        password: '',
      },
      errorMessage: null,
      isLoggin: false,
    }
  },
  methods: {
    ...mapActions({
      login: 'auth/login',
    }),
    submitLogin() {
      if (!this.form.username.length || !this.form.username.length) return

      this.errorMessage = null
      this.isLoggin = true
      this.login(this.form)
        .then(() => {
          this.$router.push({
            name: 'home',
          })
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.errorMessage = 'Nesprávný e-mail nebo heslo'
          }
        })
        .finally(() => {
          this.isLoggin = false
        })
    },
  },
}
</script>
